import { format, isValid, parseISO, subDays } from 'date-fns'

export function formatSeasonDate(
    dateStr: string | null | undefined,
    pattern = 'MMM d, yyyy',
): string {
    if (!dateStr) return '—'
    const date = parseISO(dateStr)
    if (!isValid(date)) return '—'
    return format(date, pattern)
}

export function formatSeasonDateRange(
    startDate: string | null | undefined,
    endDate: string | null | undefined,
): string | null {
    const start = formatSeasonDate(startDate)
    const end = formatSeasonDate(endDate)
    if (start === '—' && end === '—') return null
    return `${start} → ${end}`
}

export function parseSeasonDate(
    dateStr: string | null | undefined,
): Date | null {
    if (!dateStr) return null
    const date = parseISO(dateStr)
    return isValid(date) ? date : null
}

/** Calendar day as yyyy-MM-dd. Ignores incomplete / invalid picker values. */
export function seasonDateFromPicker(
    date: Date | null | undefined,
): string | null {
    if (!date || !isValid(date)) return null
    return format(date, 'yyyy-MM-dd')
}

export function seasonDatesAreOrdered(
    startDate: string | null | undefined,
    endDate: string | null | undefined,
): boolean {
    const start = parseSeasonDate(startDate)
    const end = parseSeasonDate(endDate)
    if (!start || !end) return false
    return end > start
}

/** Season window for the term being leased: it ends the day that term starts. */
export function seasonDatesFromTermStart(
    termStartDate: string | null | undefined,
): { startDate: string; endDate: string } | null {
    const end = parseSeasonDate(termStartDate)
    if (!end) return null
    return {
        startDate: format(subDays(end, 364), 'yyyy-MM-dd'),
        endDate: format(end, 'yyyy-MM-dd'),
    }
}
